import { useEffect, useState } from "react";
import axios from "axios";
import Web3 from "web3";
import "./Asset.css";
import AlgosignerUtility from "./../apis/AlgosignerUtility";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CryptoJS from 'crypto-js';
import AWS from "aws-sdk";
import { useParams, useLocation } from 'react-router-dom';
const { S3Client } = require('@aws-sdk/client-s3');
const eprcontractBuy = require("../EPRCertificate_NFTAmoy.json");
const eprcontract = require("../MyNFT_metadataAmoy.json");
var config = require("../../src/config/dev").default;

const getBuyerDisplayName = () => {
  const firstName = sessionStorage.getItem("firstName") || "";
  const lastName = sessionStorage.getItem("lastName") || "";
  return `${firstName} ${lastName}`.trim();
};

function Asset(props) {
 

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  
  coll[i].addEventListener("click", function() {
    console.log("Hiiiiiiiiiiii")
    this.classList.toggle("active1");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
    if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          } 
  });
}

  const { id } = useParams();
  const location = useLocation();

  // // Access the props from URL parameters
  // let quantityofnft = [];
  // // const sale_copies_of_nft = ""; 
  // let uom = [];
  const ownerofnft = new URLSearchParams(location.search).get('owner');
  console.log("owner39", ownerofnft);
  const assetType = new URLSearchParams(location.search).get('assetType');
  console.log("assetType", assetType);
  const TokenId = new URLSearchParams(location.search).get('TokenId');
  console.log("TokenId",TokenId);
  // quantityofnft = new URLSearchParams(location.search).get('quantity');
  // console.log("owner39", quantityofnft);
  // uom = new URLSearchParams(location.search).get('uom');
  // console.log("owner39", uom);
  // const priceofnft = new URLSearchParams(location.search).get('price');
  // const ownerNameofnft = new URLSearchParams(location.search).get('name');
  // let sale_copies_of_nft = new URLSearchParams(location.search).get('saleCopy');

  let image_link = "";
  

  
  // console.log("typesalecopynft",typeof(sale_copies_of_nft));
  // console.log("salenumbertype",typeof(valueString));
  // console.log("assetUOM",props?.nfts?.assetUom);
  
  
  
  var [showHistory , setShowHistory] = useState(false);
  const [viewnfts,setviewNfts] = useState([]);
  const [dataRefreshed, setDataRefreshed] = useState(false); // New state to trigger re-render
  const [price, setPrice] = useState("");
  const [inrUsdRate, setInrUsdRate] = useState(0);
  const [isGeneratingCbdc, setIsGeneratingCbdc] = useState(false);
  const [cbdcBalance, setCbdcBalance] = useState(null);
  const [cbdcCurrency, setCbdcCurrency] = useState("TRC-TOKEN");
  const [isFetchingBalance, setIsFetchingBalance] = useState(false);
  const [cbdcTxHistory, setCbdcTxHistory] = useState([]);
  const [showCbdcTxPanel, setShowCbdcTxPanel] = useState(false);
  const [ownerTableOpen, setOwnerTableOpen] = useState(true);
  const [owner, setOwner] = useState("");
  const [salecopies, setSalecopies] = useState("");
  const [prov_hash, setProvhash] = useState("");
  const [str, setStr]= useState("");
  const [numNfts, setNumNfts] = useState("");
  const [salenft, setsaleNfts] = useState("");
  // const [sale, setSale] = useState("");
  // const [loyaltypoints, setLoyaltyPoints] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  
  // console.log(typeof(totalPrice),"totalPrice118");
  const [maticPrice, setMaticPrice] = useState(0);
  const [p_hash, setPhash ]= useState("");
  const [localDate1, setLocalDate1] = useState('');
  const [localTime1, setLocalTime1] = useState('');
  const [isMobile, setIsMobile] = useState(false); 
  let sale = "";
  let utcTimestamp = ""
  let localDate = "";
  let localTime = "";
  let createdDate = "";
  let utcTimestamp1 = "";
  const [valueString, setvalueString] =  useState("");
  const [sale_copies_of_nft, setsale_copies_of_nft] = useState("0");
  const [quantityofnft, setquantityofnft] = useState("");
  const [uom, setuom] = useState("");
  const [priceofnft, setpriceofnft] = useState("");
  const [ownerNameofnft, setownerNameofnft] = useState("");
  const [selectedOwner, setSelectedOwner] = useState(ownerofnft);
  const [cbdcWalletId, setCbdcWalletId] = useState(localStorage.getItem("buyerCbdcWalletId") || "");


  useEffect(() => {

        // Detect if user is on a mobile device
        const checkIfMobile = () => {
          const userAgent = navigator.userAgent || navigator.vendor || window.opera;
          if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            setIsMobile(true);
          }
        };
        checkIfMobile();
   
    console.log("props",props);
    const loadNonEPRDataFromProps = () => {
      if (!props?.nfts?.nft_sale) return;
      const ownerSaleData = props.nfts.nft_sale.find(
        sale => sale.owner === ownerofnft
      ) || props.nfts.nft_sale[0];
      if (!ownerSaleData) return;
      console.log("ownerSaleData (from props):", ownerSaleData);
      setpriceofnft(ownerSaleData.fixedPrice);
      setownerNameofnft(ownerSaleData.ownerName);
      setquantityofnft(ownerSaleData.ownedCopies);
      setsale_copies_of_nft(ownerSaleData.sale_copies);
      setuom(props.nfts.AssetUom || props.nfts.assetUom || "");
      setvalueString(ownerSaleData.sale_copies);
    };
    if (assetType === "NonEprAsset") {
      loadNonEPRDataFromProps();
    }

    function setAndGet(urlParams, key, value) {
      urlParams.set(key, value); // Set the key-value pair
      return urlParams.get(key); // Return the value
  }

    const loadEPRDataFromProps = () => {
      if (!props?.nfts?.nft_sale) return null;
      const techNames = props.nfts.certNumber
        ? props.nfts.certNumber.split("/")[1]
        : "";
      const ownerSaleData = props.nfts.nft_sale.find(
        sale => sale.owner === ownerofnft?.toLowerCase()
      ) || props.nfts.nft_sale[0];
      if (!ownerSaleData) return null;
      console.log("ownerSaleData (from props):", ownerSaleData);
      setpriceofnft(ownerSaleData.fixedPrice);
      setownerNameofnft(ownerSaleData.ownerName || techNames);
      setquantityofnft(ownerSaleData.ownedCopies);
      setsale_copies_of_nft(ownerSaleData.sale_copies);
      setNumNfts(ownerSaleData.sale_copies);
      setuom(props.nfts.eprAssetUom || "");
      setvalueString(ownerSaleData.sale_copies);
      return { sale_copies: ownerSaleData.sale_copies, fixedPrice: ownerSaleData.fixedPrice };
    };
    let eprData = null;
    if (assetType === "EPRAsset") {
      eprData = loadEPRDataFromProps();
    }

     const fetchAsset = async () => {
      console.log("networktype:",props?.nfts?.network_type);
      console.log("assetType",assetType);
       createdDate = props?.nfts?.created_on;
       console.log("createdDate",createdDate);
       utcTimestamp1 = new Date(createdDate);
       console.log("utcTimestamp1",utcTimestamp1);
       setLocalDate1(utcTimestamp1.toLocaleDateString());
       setLocalTime1(utcTimestamp1.toLocaleTimeString());
       console.log("localTimestamp11",localDate1 , localTime1);
      // console.log("props",props.nfts.network_type)
      if (props?.nfts?.network_type === "hyperledger" || isFabricNetwork()) {
        // Fetch INR → USD rate for Fabric/CBDC assets
        axios.get("https://api.frankfurter.app/latest?from=INR&to=USD")
          .then((res) => {
            const rate = parseFloat(res.data?.rates?.USD);
            if (!isNaN(rate) && rate > 0) {
              setInrUsdRate(rate);
              if (assetType === "EPRAsset" && eprData) {
                const qty = parseFloat(eprData.sale_copies) || 0;
                const fixedP = parseFloat(eprData.fixedPrice) || 0;
                const totalINR = qty * fixedP;
                setMaticPrice(totalINR.toFixed(4));
                setTotalPrice(formatUSD(totalINR * rate));
              }
            }
          })
          .catch(() => {
            // Fallback: 1 INR ≈ 0.012 USD
            const fallbackRate = 0.012;
            setInrUsdRate(fallbackRate);
            if (assetType === "EPRAsset" && eprData) {
              const qty = parseFloat(eprData.sale_copies) || 0;
              const fixedP = parseFloat(eprData.fixedPrice) || 0;
              const totalINR = qty * fixedP;
              setMaticPrice(totalINR.toFixed(4));
              setTotalPrice(formatUSD(totalINR * fallbackRate));
            }
          });
      } else {
      // Fetch 1 MATIC (or ALGO) = ? USD from CoinGecko via local server proxy
      const convertToken = props?.nfts?.network_type === "polygon" ? "MATIC" : "ALGO";
      axios
        .get(`/api/price?convert=${convertToken}`)
        .then(function (response) {
          // response.data.price = USD per 1 MATIC (or ALGO), e.g. 0.4567
          const usdPerToken = parseFloat(response.data.price);
          if (isNaN(usdPerToken) || usdPerToken <= 0) return;
          setPrice(usdPerToken.toString());
          if (assetType === "EPRAsset" && eprData) {
            const qty = parseFloat(eprData.sale_copies) || 0;
            const fixedP = parseFloat(eprData.fixedPrice) || 0;
            const totalMatic = qty * fixedP;
            setMaticPrice(totalMatic.toFixed(6));
            // totalUSD = totalMATIC × (USD per MATIC)
            setTotalPrice((totalMatic * usdPerToken).toFixed(4));
          }
        })
        .catch(function (error) {
          console.log("Price API error:", error.message);
          if (assetType === "EPRAsset" && eprData) {
            const qty = parseFloat(eprData.sale_copies) || 0;
            const fixedP = parseFloat(eprData.fixedPrice) || 0;
            setMaticPrice((qty * fixedP).toFixed(6));
            setTotalPrice("N/A");
          }
        });
      }
    
    };

     fetchAsset();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Adapts decimal places so tiny USD values never display as "0.0000"
  const formatUSD = (val) => {
    if (!val || isNaN(val) || val === 0) return "0.00";
    if (val >= 0.01)     return val.toFixed(4);
    if (val >= 0.000001) return val.toFixed(6);
    return val.toPrecision(4);
  };

  const handleNumNftsInputEPR = (event) => {
    const numNfts1 = parseFloat(event.target.value);
    setNumNfts(numNfts1);
    if (!isNaN(numNfts1) && numNfts1 > 0) {
      const pricePerUnit = parseFloat(priceofnft) || 0;
      if (isFabricNetwork()) {
        // For Hyperledger Fabric: price is in INR (CBDC digital currency)
        const totalINR = numNfts1 * pricePerUnit;
        setMaticPrice(totalINR.toFixed(4));
        const rate = inrUsdRate > 0 ? inrUsdRate : 0.012;
        setTotalPrice(formatUSD(totalINR * rate));
      } else {
        const totalMatic = numNfts1 * pricePerUnit;
        // 6 decimal places — small MATIC values like 0.004 round to "0.00" with toFixed(2)
        setMaticPrice(totalMatic.toFixed(6));
        // price state = USD per 1 MATIC (from CoinGecko), so totalUSD = totalMatic × price
        const usdPerMatic = parseFloat(price);
        if (!isNaN(usdPerMatic) && usdPerMatic > 0) {
          setTotalPrice((totalMatic * usdPerMatic).toFixed(4));
        } else {
          setTotalPrice("N/A");
        }
      }
    } else {
      setTotalPrice("");
      setMaticPrice("");
    }
  };
  //Dynamic Price Calculation in Popup
  const handleNumNftsInput = (event) => {
    const numNfts = parseFloat(event.target.value);
    setNumNfts(numNfts);
    if (!isNaN(numNfts) && numNfts > 0) {
      const pricePerUnit = parseFloat(priceofnft) || 0;
      if (isFabricNetwork()) {
        // For Hyperledger Fabric: price is in INR (CBDC digital currency)
        const totalINR = numNfts * pricePerUnit;
        setMaticPrice(totalINR.toFixed(4));
        const rate = inrUsdRate > 0 ? inrUsdRate : 0.012;
        setTotalPrice(formatUSD(totalINR * rate));
      } else {
        setTotalPrice((numNfts * (price * priceofnft)).toFixed(2));
        setMaticPrice((numNfts * priceofnft).toFixed(6));
      }
    } else {
      setTotalPrice("");
      setMaticPrice("");
    }
  };
//------------------------------------------------------------------------Ethereum.enable change------------------------------------------------
// // Put code that comes after Credit here
const handleTransactionComplete = async (txHash) => {
  const web3 = new Web3(window.ethereum);
  const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
 
//-------------------------------------------------------------------ethereum.enable change--------------------------------------------------------

    // const EPRContractAddress = "0x9C84297B7f08c8f85AE5E18503689C4f11aE70b6";
    const EPRContractAddress = "0x7B08e049ebae3eCED91a234223D23E97e4B7770e"
   
    console.log("ABI: ", eprcontract.output.abi);
    console.log(window.ethereum.isConnected());

    const eprContract = new web3.eth.Contract(
      eprcontract.output.abi,
      EPRContractAddress
    ); //removed window from here
    console.log("Crypto received, calling smart contract now!");
    await eprContract.methods
      .transfer(
        //certnumber,
        props.nfts.certNumber,
        //From Address
        props.nfts.nft_sale[0].owner,
        //To Address
        accounts[0],
        //totalquantity,
        numNfts
        //this.EPR_PUBLIC_KEY,
        //txHash
        //event.asset.epr_hash
      )
      .send({ from: accounts[0] }) //.send() - writing data to blockchain (Metamask to Account address)
      .on("error", function (error) {
        console.error("Error occurred while transferring NFT:", error);
      })
      //Console this for error
      .then(function (receipt) {
        return receipt;
      });
  };

  const buy = async(token, from, to, amount) => {    
    console.log("in buy 439",token, from, to, amount);
    console.log("INSIDE BUY");
    
    const web3 = new Web3(window.ethereum);
    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    // const EPRContractAddress = "0x9C84297B7f08c8f85AE5E18503689C4f11aE70b6";
    const EPRContractAddress = "0x7B08e049ebae3eCED91a234223D23E97e4B7770e"


    console.log("ABI: ", eprcontract.abi);
    console.log(window.ethereum.isConnected());

    const eprContract = new web3.eth.Contract(
      eprcontract.output.abi,
      EPRContractAddress
    ); 
    console.log("ABI: ", eprContract);
    console.log("Receiver of NFT:", to);
    console.log("Amount being transferred:", amount);
    console.log("Using ownerofnft as from:", ownerofnft);
    console.log("Parameters",props.nfts.assetId, ownerofnft, to, amount);
    console.log("Crypto received, calling smart contract now!",ownerofnft,accounts[0],token);

    try{
      console.log("Calling smart contract 'buy' function");
      const gasPrice = await web3.eth.getGasPrice();
      console.log("Gas Price on network",gasPrice);

    const nftTx = await eprContract.methods    
    .transfer(props.nfts.assetId, ownerofnft, to, amount)
    .send({ 
      from: accounts[0],
      gas:800000, 
      gasPrice:gasPrice,
    });
    
    console.log("NFT Transaction hash:", nftTx.transactionHash);
     await monitorTransactionStatus(web3, nftTx.transactionHash);
    
      if(nftTx.status){
        console.log("Transaction Successful", nftTx);  // Added log
       var nftDetailsData ={
                    assetId: props.nfts.assetId,
                    material_received:"true",
                    transactionProcess:"manual",
                    nft_sale:[{
                       owner: accounts[0],
                       ownerName: getBuyerDisplayName(),
                       ownedCopies: Number(numNfts),
                      //  previous_owner: props.nfts.nft_sale[0].owner
                      previous_owner: ownerofnft
                      }
                    ]
                  }
                  console.log("NFT Transaction successful, updating backend...");
                  console.log("nftDetailsData being sent to the server:", nftDetailsData);

                  const updatetokenTransfer = await fetch(config.API_ENDPOINT+'src/v1/nftdetails/update_nftdetails',{
                    method:"put",
                    headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
                    body:JSON.stringify(nftDetailsData)       
                      
                  })
                  console.log("Response from update_nftdetails API:", updatetokenTransfer);
                      
                  // Fetch updated data
          			const fetchUpdatedData = async () => {
                console.log("Fetching updated NFT details...");  

                const result = await fetch(config.API_ENDPOINT + 'src/v1/nftdetails?tokenId=' + TokenId, {
                      method:"get",  
                      headers: {
                        'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                        },
                    }).then((response) => response.json())
                    .then((result) => {
                      
                      console.log("res",result);
                      console.log("ownedcopiesUpdated", result.data.result[0].nft_sale[0].ownedCopies);
                      console.log("salecopiesupdated", result.data.result[0].nft_sale[0].sale_copies);
                      quantityofnft = result.data.result[0].nft_sale[0].ownedCopies;
                      console.log("quantity326",quantityofnft);
                      sale_copies_of_nft = result.data.result[0].nft_sale[0].sale_copies;
                      console.log("sale_copies_of_nft",sale_copies_of_nft);
                    });
                    result();
                    
                  console.log("Result of updated data fetch:", result);
					    //     const ownerSaleData = result.data.result[0].nft_sale.find(sale => sale.owner === ownerofnft); 
					    //     if (!ownerSaleData) {
              //  			console.error("Could not find nft_sale entry for ownerofnft");
             	// 	 	return;
             	// 	 } 
              //     // quantityofnft = result.data.result[0].nft_sale[0].ownedCopies;
              //     quantityofnft = ownerSaleData.ownedCopies;
              //     sale_copies_of_nft = ownerSaleData.sale_copies;
              //     console.log("Updated quantity:", quantityofnft);
            	// 	  console.log("Updated sale copies:", sale_copies_of_nft);

              //   // Update the URL with new values
            	// 	const urlParams = new URLSearchParams(window.location.search);
            	// 	urlParams.set('quantity', quantityofnft);
            	// 	urlParams.set('saleCopy', sale_copies_of_nft);
            	// 	window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
              // };
              // await fetchUpdatedData();
                  }
            }
      toast.success("Token Transfer is completed!", {
        position:'top-center',
        autoClose:3000,     
     });
      setTimeout(() => {
      window.location.href = config.Local_ENDPOINT+`asset/${props.nfts.tokenId}/${assetType}?assetType=${assetType}&TokenId=${TokenId}`;
      }, 2000);
  }  catch (error) {
    console.log("errrrrorrrr", error);
    if (error.code == 4001) {
      toast.error("Error: User denied transaction signature", {
        position: 'top-center',
        autoClose: 3000,
      });
    } else if (error.message.includes("Transaction was not mined within 50 blocks")) {
      toast.error("Error: Transaction took too long. Check the network status and try again later.", {
        position: 'top-center',
        autoClose: 3000,
      });
    } else {
      toast.error("Error: Transaction failed. Please check the status later.", {
        position: 'top-center',
        autoClose: 3000,
      });
    }
  }
};

  //Confirm Purchase Button Click
  const handleConfirmPurchaseClick = async () => {
    console.log("ownerofnft",ownerofnft);
    
    try {
      // Check if MetaMask is installed
      if (typeof window.ethereum !== "undefined") {
        // Check if the network is Polygon Testnet
        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        if (chainId !== "0x13882") {
          try {
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: "0x13882" }],
            });
          } catch (switchError) {
            if (switchError.code === 4902) {
              await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [{
                  chainId: "0x13882",
                  chainName: "Polygon Amoy Testnet",
                  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
                  rpcUrls: ["https://rpc-amoy.polygon.technology/"],
                  blockExplorerUrls: ["https://www.oklink.com/amoy"],
                }],
              });
            } else {
              toast.error("Please switch to Polygon Amoy Testnet in MetaMask.", {
                position: 'top-center',
                autoClose: 4000,
              });
              return;
            }
          }
        }
        if (isMobile) {
          // Redirect to MetaMask mobile app on mobile devices
          const deeplinkUrl = `https://metamask.app.link/dapp/${window.location.hostname}`;
          window.location.href = deeplinkUrl;
          return;
        }
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        // Create Web3 instance
        const web3 = new Web3(window.ethereum);
        // Get the selected account
        const accounts = await web3.eth.getAccounts();
        const from = accounts[0];


      if (from.toLowerCase() === ownerofnft.toLowerCase()) {
          console.log("Sender and recipient addresses cannot be the same");
          toast.error("Error : "+"Sender and recipient addresses cannot be the same", {
            position:'top-center',
            autoClose:3000,
          
         });
          return;
        }
        document.getElementById("confirmspin").style.display = "block"
        const amount = web3.utils.toWei(totalPrice, "ether");

        const gasPrice = await web3.eth.getGasPrice();
        console.log("GasPrice on network",gasPrice);
        // Send the transaction
        const maticTx  = await web3.eth.sendTransaction({
          from,
          to:ownerofnft,
          value: amount,
          gas: 800000,
          gasPrice:gasPrice,
          data: "0x",
        });
        console.log("Matic Transaction hash:", maticTx.transactionHash); // Save initial hash
      await monitorTransactionStatus(web3, maticTx.transactionHash);
      console.log("Monitore transaction",monitorTransactionStatus)
        
        if (maticTx.status) {
          document.getElementById("confirmspin").style.display = "block"
          buy(props?.nfts?.tokenId,props?.nfts?.nft_sale[0]?.owner,accounts[0],numNfts)
          
          toast.success("Matic Transfer is completed! Wait for Token Transfer", {
            position:'top-center',
            autoClose:3000,
           
         });

          console.log("CRYPTO TRANSFER DONE");
        }
      } else {
        console.log("MetaMask is not installed");
      }
    } catch (error) {
      console.error(error);
     if(error == "Error: while converting number to string, invalid number value '', should be a number matching (^-?[0-9.]+).")
      {
      toast.error("Error : "+"Quantity cannot be null", {
        position:'top-center',
        autoClose:3000,
        onClose: () => {window.location.href = config.Local_ENDPOINT+`asset/${props.nfts.tokenId}/${assetType}?owner=${ownerofnft}&assetType=${assetType}&TokenId=${TokenId}`}
     });
    } else {
      toast.error("Error : "+"User Denied Transaction", {
        position:'top-center',
        autoClose:3000,
        onClose: () => {window.location.href = config.Local_ENDPOINT+`asset/${props.nfts.tokenId}/${assetType}?owner=${ownerofnft}&assetType=${assetType}&TokenId=${TokenId}`}
     });
    }
    }
    
  };


  const handleConfirmPurchaseClickEPR = async () => {
    
    try {
      // Check if MetaMask is installed
      if (typeof window.ethereum !== "undefined") {
        // Check if the network is Polygon Testnet
        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        if (chainId !== "0x13882") {
          try {
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: "0x13882" }],
            });
          } catch (switchError) {
            if (switchError.code === 4902) {
              await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [{
                  chainId: "0x13882",
                  chainName: "Polygon Amoy Testnet",
                  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
                  rpcUrls: ["https://rpc-amoy.polygon.technology/"],
                  blockExplorerUrls: ["https://www.oklink.com/amoy"],
                }],
              });
            } else {
              toast.error("Please switch to Polygon Amoy Testnet in MetaMask.", {
                position: 'top-center',
                autoClose: 4000,
              });
              return;
            }
          }
        }

        // Deep link to MetaMask app if on mobile
      if (isMobile) {
        const deeplinkUrl = `https://metamask.app.link/dapp/${window.location.hostname}`;
        window.location.href = deeplinkUrl;
        return;
      }
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        // Create Web3 instance
        const web3 = new Web3(window.ethereum);
        // Get the selected account
        const accounts = await web3.eth.getAccounts();
        const from = accounts[0];
        console.log("ownernft",ownerofnft);
        console.log("owner",owner);
        console.log("salecopies",salecopies);

        const to = selectedOwner;
        console.log("MetaMask Account (from):", from);

        console.log("NFT Owner (to):", to);
        // Check if the sender and recipient addresses are different
        if (from.toLowerCase() === to.toLowerCase()) {
          console.log("Sender and recipient addresses cannot be the same");
          toast.error("Error : "+"Sender and recipient addresses cannot be the same", {
            position:'top-center',
            autoClose:3000,
         });
          return;
        }

        // Validate amount before sending - use maticPrice (qty × fixedPrice in MATIC)
        const maticAmount = parseFloat(maticPrice);
        if (!maticAmount || isNaN(maticAmount) || maticAmount <= 0) {
          toast.error("Invalid purchase amount. Please ensure quantity and price are set correctly.", {
            position: 'top-center',
            autoClose: 4000,
          });
          return;
        }
        const qty = parseFloat(numNfts);
        if (!qty || isNaN(qty) || qty <= 0) {
          toast.error("Please enter a valid quantity greater than 0.", {
            position: 'top-center',
            autoClose: 3000,
          });
          return;
        }

        console.log("maticAmount to send:", maticAmount, "MATIC");
        document.getElementById("confirmspin").style.display = "block";
        const amount = web3.utils.toWei(maticAmount.toString(), "ether");
        const gasPrice = await web3.eth.getGasPrice();
        console.log("GasPrice on network", gasPrice);

        const maticTx = await web3.eth.sendTransaction({
          from,
          to,
          value: amount,
          gas: 800000,
          gasPrice: gasPrice,
          data: "0x",
        });
        console.log("Matic Transaction hash:", maticTx.transactionHash);
        await monitorTransactionStatus(web3, maticTx.transactionHash);

        if (maticTx.status) {
          document.getElementById("confirmspin").style.display = "block";
          buyEPR(props?.nfts?.tokenId, selectedOwner.toLowerCase(), accounts[0], qty);
          toast.success("MATIC transfer complete! Waiting for token transfer...", {
            position: 'top-center',
            autoClose: 3000,
          });
          console.log("CRYPTO TRANSFER DONE");
        }
      } else {
        toast.error("MetaMask is not installed. Please install MetaMask to proceed.", {
          position: 'top-center',
          autoClose: 4000,
        });
      }
    } catch (error) {
      document.getElementById("confirmspin").style.display = "none";
      console.error(error);
      if (error.code === 4001) {
        toast.error("Transaction cancelled by user.", {
          position: 'top-center',
          autoClose: 3000,
        });
      } else if (error.message && error.message.includes("invalid number value")) {
        toast.error("Invalid amount. Please check the quantity and try again.", {
          position: 'top-center',
          autoClose: 3000,
        });
      } else if (error.message && error.message.includes("insufficient funds")) {
        toast.error("Insufficient MATIC balance in your wallet.", {
          position: 'top-center',
          autoClose: 4000,
        });
      } else {
        toast.error("Transaction failed: " + (error.message || error), {
          position: 'top-center',
          autoClose: 4000,
        });
      }
    }
    
    
  };

  const buyEPR = async(token, from, to, amount) => {
      console.log("INSIDE BUY");
  const web3 = new Web3(window.ethereum);
  await window.ethereum.request({ method: 'eth_requestAccounts' });
  const accounts = await web3.eth.getAccounts();

    const EPRContractAddress = "0x1c36a5B65a44744f0F536b922edd07669aF8565e";
 
    const eprcontractBuyEPR = new web3.eth.Contract(
      eprcontractBuy.output.abi,
      EPRContractAddress
    ); //removed window from here
    console.log("Parameters",props.nfts.certNumber, from, to, amount);
    try{
      const gasPrice = await web3.eth.getGasPrice();
      console.log("GasPrice on network",gasPrice);

      // ── Pre-flight checks ──────────────────────────────────────────────────
      // 1. Verify the cert number is registered on-chain
      const tokenId = await eprcontractBuyEPR.methods.certnumbertoNFTid(props.nfts.certNumber).call();
      console.log("On-chain tokenId for certNumber:", tokenId);
      if (Number(tokenId) === 0) {
        toast.error("This EPR certificate is not registered on-chain. Please contact the admin to mint it first.", {
          position: 'top-center', autoClose: 7000,
        });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }

      // 2. Ensure seller has enough tokens registered on-sale (putOnSaleGrid must have been called)
      // const onSaleQty = await eprcontractBuyEPR.methods.tokensOnSale(from, tokenId).call();
      // console.log("tokensOnSale for seller:", onSaleQty, "requested amount:", amount);
      // if (Number(onSaleQty) < Number(amount)) {
      //   // Automatically call putOnSaleGrid from the buyer-connected account
      //   // (won't work if seller ≠ buyer) — so just show a clear message
      //   toast.error(
      //     `Seller has not registered tokens on-chain for sale (on-sale: ${onSaleQty}, needed: ${amount}). ` +
      //     "The seller must go to 'My NFTs' and click 'Approve for Sale' first.",
      //     { position: 'top-center', autoClose: 8000 }
      //   );
      //   document.getElementById("confirmspin").style.display = "none";
      //   return;
      // }

      // 3. Verify seller's on-chain balance
      const sellerBalance = await eprcontractBuyEPR.methods.balanceOf(from, tokenId).call();
      console.log("Seller on-chain balance:", sellerBalance);
      if (Number(sellerBalance) < Number(amount)) {
        toast.error(
          `Seller's on-chain token balance (${sellerBalance}) is less than the requested amount (${amount}). ` +
          "Please contact the admin.",
          { position: 'top-center', autoClose: 7000 }
        );
        document.getElementById("confirmspin").style.display = "none";
        return;
      }

      // 4. Verify the contract is approved as an operator for the seller (needed for transfer)
      // const isApproved = await eprcontractBuyEPR.methods.isApprovedForAll(from, EPRContractAddress).call();
      // console.log("isApprovedForAll(seller, contract):", isApproved);
      // if (!isApproved) {
      //   toast.error(
      //     "The seller has not approved this contract for trading. " +
      //     "The seller must go to 'My NFTs' and click 'Approve for Sale' first.",
      //     { position: 'top-center', autoClose: 8000 }
      //   );
      //   document.getElementById("confirmspin").style.display = "none";
      //   return;
      // }
      // ── End pre-flight checks ──────────────────────────────────────────────

     const nftTx = await eprcontractBuyEPR.methods

    .transfer(props.nfts.certNumber, from, to, amount)
    .send({
      from: accounts[0],
      gas:800000,
      gasPrice:gasPrice

    })
    console.log("NFT Transaction hash:", nftTx.transactionHash);
    await monitorTransactionStatus(web3, nftTx.transactionHash);
    
      if(nftTx.status){
        console.log("Transaction Successful", nftTx);
        // from = seller (previous owner), to = buyer, amount = qty purchased
        var nftDetailsData = {
          assetId: props.nfts.assetId,
          material_received: "true",
          transactionProcess: "manual",
          nft_sale: [{
            owner: to,               // buyer's address
            ownerName: getBuyerDisplayName(),
            ownedCopies: Number(amount),
            previous_owner: from     // seller's address
          }],
        };
        const updatetokenTransfer = await fetch(config.API_ENDPOINT + 'src/v1/eprnftdetails/update_nftdetails', {
          method: "put",
          headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
          body: JSON.stringify(nftDetailsData)
        });
        console.log("update", updatetokenTransfer);
        toast.success("Token Transfer is completed! Reloading...", {
          position: 'top-center',
          autoClose: 2000,
        });
        // Reload without owner filter so the full updated table is shown (all owners)
        setTimeout(() => {
          window.location.href = config.Local_ENDPOINT + `asset/${TokenId}/${assetType}?assetType=${assetType}&TokenId=${TokenId}`;
        }, 2000);
    }
  } catch (error) {
    console.log("errrrrorrrr", error);
    if (error.code == 4001) {
      toast.error("Error : " + "User denied transaction signature", {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          window.location.href = config.Local_ENDPOINT + `asset/${props.nfts.tokenId}/${assetType}?owner=${ownerofnft}&assetType=${assetType}&TokenId=${TokenId}`;
        },
      });
      console.log("----Error----");
    } else if (error.message.includes("Transaction was not mined within 50 blocks")) {
      toast.error("Error: Transaction took too long. Check the network status and try again later.", {
        position: 'top-center',
        autoClose: 3000,
      });
    } else {
      toast.error("Error: Transaction failed. Please check the status later.", {
        position: 'top-center',
        autoClose: 3000,
      });
    }
  }
};


  const monitorTransactionStatus = async (web3, txHash) => {
    let receipt = null;
    while (receipt === null) {
      try {
        receipt = await web3.eth.getTransactionReceipt(txHash);
        if (receipt && receipt.status) {
          return;
        } else if (receipt && !receipt.status) {
          throw new Error("Transaction failed");
        }
      } catch (error) {
        console.log("Error checking transaction status:", error);
        throw error;
      }
      await new Promise(resolve => setTimeout(resolve, 5000)); // Wait for 5 seconds before checking again
    }
  };
  

  //Closing modal popup
  const handleCloseModal = () => {
    setNumNfts("");
    setTotalPrice(0);
    setCbdcWalletId("");
    // setshowModal(false)
  };

  const isDisabled = numNfts === 0 || isNaN(numNfts);


  const buyWithAlgos = async() => {
    console.log("Inside buywith algo");
    try {
        const connection = await AlgosignerUtility.checkAlgoSignerWallet1(true);
        console.log("connection------",connection);
        document.getElementById("confirmspin").style.display = "block"
        if (!connection) {
            console.log("Inside IF");
            return;
        }   

        const optInNFT = await axios.post(config.API_Algo_ENDPOINT+'marketplacecheckoptin',{
         
            body: {
              
              "Purchaser" : connection[0], 
              "Token_Id" :  Number(props.nfts.tokenId)
            }
           
            })

            console.log("optInNFT-------", optInNFT); 

            if(optInNFT.data.OptinCheck == true){
              document.getElementById("confirmspin").style.display = "block"
            const paymentTransaction = await axios.post(config.API_Algo_ENDPOINT+'useralgopayment',{
         
            body: {
                "Sender":connection[0],
                "Receiver":"OOF7CR65VIJIKYUXRWBENSIUQVW6YHUL7M5ONCZHYFD7JBQO33EF7MCHTQ",
                "Amount": Number(totalPrice * 1000000)
            }
           
            })
          
            // console.log("error");
            console.log("paymentTxn-------", paymentTransaction); 
           
        if(paymentTransaction.data.status == "Transaction Created"){
        document.getElementById("confirmspin").style.display = "block"
        console.log(" paymentTransaction.data.transaction", paymentTransaction.data.transaction);
        const paymentTxnResponse = await AlgosignerUtility.signAndSendTxn(
            paymentTransaction.data.transaction
        ).then(async(paymentTxnResponse) => {
          
            console.log("PaymentTXNResponse---------", paymentTxnResponse);

            var supply = parseFloat(numNfts).toFixed(2);
            if(paymentTxnResponse !== undefined){
            const tokenTransfer = await axios.post(config.API_Algo_ENDPOINT+'marketplacetokentransfer',{
             
           

                    body: {
                        "Receiver":connection[0],
                        "No_Of_Tokens" :parseFloat(supply),
                        "Token_ID" : Number(props.nfts.tokenId)
                        
                     }        
                })

                console.log("TransferToken", tokenTransfer);
                if(tokenTransfer.data.status == "Token Transfered"){
                  var nftDetailsData ={
                    assetId: props.nfts.assetId,
                    material_received:"true",
                    transactionProcess:"manual",
                    nft_sale:[{
                       owner: connection[0],
                       ownerName: getBuyerDisplayName(),
                       ownedCopies: Number(numNfts),
                       previous_owner: props.nfts.nft_sale[0].owner
                      }
                    ]
                  }

                  console.log("props597",props);
                  const updatetokenTransfer = await fetch(config.API_ENDPOINT+'src/v1/nftdetails/update_nftdetails',{
                    method:"put",
                    headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
                    body:JSON.stringify(nftDetailsData)       
                      
                  })
                      console.log("update",updatetokenTransfer);
                      


                    var supply1 = parseInt(5).toFixed(2);
                    const fungibletokenTransfer = await axios.post(config.API_Algo_ENDPOINT+'loyaltytransfer',{
                    
                      
                      
                      body: 
                      {
                        "Receiver" : connection[0], 
                        "No_Of_Tokens" : parseFloat(supply1), 
                        "Token_ID" : 172073882
                       }   
                      
                  })
                  console.log("fungible token transfer",fungibletokenTransfer); 
                  
                  var tokenId = props.nfts.tokenId
                      console.log("tokenId",tokenId);
                     const data  = async () => await fetch(config.API_ENDPOINT+'src/v1/nftdetails?tokenId='+tokenId,{
                      // await axios.get(config.API_ENDPOINT+'src/v1/nftdetails/'+props.nfts.tokenId, {
                      method:"get",  
                      headers: {
                        'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                        },
                        
        
                    }) .then((response) => response.json())
                    .then((result) => {
                      
                      console.log("res",result);
                      console.log("ownedcopiesUpdated", result.data.result[0].nft_sale[0].ownedCopies);
                      console.log("salecopiesupdated", result.data.result[0].nft_sale[0].sale_copies);
                      quantityofnft = result.data.result[0].nft_sale[0].ownedCopies;
                      console.log("quantity326",quantityofnft);
                      sale_copies_of_nft = result.data.result[0].nft_sale[0].sale_copies;
                      console.log("sale_copies_of_nft",sale_copies_of_nft);
                      
                    })
                    data();
                }
               
            }
        })
        
        document.getElementById("confirmspin").style.display = "none"
        toast.success("Asset Transferred Successfully!!", {
          position:'top-center',
          autoClose:3000,
       });
      }

               

              
  }

            if(optInNFT.data.OptinCheck == false){
              document.getElementById("confirmspin").style.display = "block"
              
              const optIN = await axios.post (config.API_Algo_ENDPOINT+'marketplacetokenoptin',{
              
              body:  {
               "Purchaser" : connection[0] ,
               "Token_Id" : Number(props.nfts.tokenId)
              }

            })
            console.log("optIn___",optIN);

            if(optIN.data.status == "Transaction Created"){
              document.getElementById("confirmspin").style.display = "block"
              const optInResponse = await AlgosignerUtility.signAndSendTxn(
                  optIN.data.transaction
              ).then(async(optInResponse) => {
               console.log("optInResponse",optInResponse);

               if(optInResponse !== undefined){
                
                const paymentTransaction = await axios.post(config.API_Algo_ENDPOINT+'useralgopayment',{
         
            body: {
                "Sender":connection[0],
                "Receiver":"OOF7CR65VIJIKYUXRWBENSIUQVW6YHUL7M5ONCZHYFD7JBQO33EF7MCHTQ",
                "Amount": Number(totalPrice * 1000000)
            }
           
            })
          
            // console.log("error");
            console.log("paymentTxn-------", paymentTransaction); 
           
        if(paymentTransaction.data.status == "Transaction Created"){
        document.getElementById("confirmspin").style.display = "block"
        const paymentTxnResponse = await AlgosignerUtility.signAndSendTxn(
            paymentTransaction.data.transaction
        ).then(async(paymentTxnResponse) => {
          
            console.log("PaymentTXNResponse---------", paymentTxnResponse);

            var supply = parseFloat(numNfts).toFixed(2);
            if(paymentTxnResponse !== undefined){
            const tokenTransfer = await axios.post(config.API_Algo_ENDPOINT+'marketplacetokentransfer',{
             
           

                    body: {
                        "Receiver":connection[0],
                        "No_Of_Tokens" :parseFloat(supply),
                        "Token_ID" : Number(props.nfts.tokenId)
                        
                     }        
                })

                console.log("TransferToken", tokenTransfer);
                if(tokenTransfer.data.status == "Token Transfered"){
                  var nftDetailsData ={
                    assetId: props.nfts.assetId,
                    material_received:"true",
                    transactionProcess:"manual",
                    nft_sale:[{
                       owner: connection[0],
                       ownerName: getBuyerDisplayName(),
                       ownedCopies: Number(numNfts),
                       previous_owner: props.nfts.nft_sale[0].owner
                      }
                    ]
                  }

                  console.log("props741",props)
                  const updatetokenTransfer = await fetch(config.API_ENDPOINT+'src/v1/nftdetails/update_nftdetails',{
                    method:"put",
                    headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
                    body:JSON.stringify(nftDetailsData)       
                      
                  })
                      console.log("update",updatetokenTransfer);
                      


                    var supply1 = parseInt(5).toFixed(2);
                    const fungibletokenTransfer = await axios.post(config.API_Algo_ENDPOINT+'loyaltytransfer',{
                    
                      
                      
                      body: 
                      {
                        "Receiver" : connection[0], 
                        "No_Of_Tokens" : parseFloat(supply1), 
                        "Token_ID" : 172073882
                       }   
                      
                  })
                  console.log("fungible token transfer",fungibletokenTransfer); 
                  
                  var tokenId = props.nfts.tokenId
                      console.log("tokenId",tokenId);
                     const data  = async () => await fetch(config.API_ENDPOINT+'src/v1/nftdetails?tokenId='+tokenId,{
                      // await axios.get(config.API_ENDPOINT+'src/v1/nftdetails/'+props.nfts.tokenId, {
                      method:"get",  
                      headers: {
                        'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                        },
                        
        
                    }) .then((response) => response.json())
                    .then((result) => {
                      
                      console.log("res",result);
                      console.log("ownedcopiesUpdated", result.data.result[0].nft_sale[0].ownedCopies);
                      console.log("salecopiesupdated", result.data.result[0].nft_sale[0].sale_copies);
                      quantityofnft = result.data.result[0].nft_sale[0].ownedCopies;
                      console.log("quantity326",quantityofnft);
                      sale_copies_of_nft = result.data.result[0].nft_sale[0].sale_copies;
                      console.log("sale_copies_of_nft",sale_copies_of_nft);
                      
                    })
                    data();
                }
               
            }
        })
        
        document.getElementById("confirmspin").style.display = "none"
        toast.success("Asset Transferred Successfully!!", {
          position:'top-center',
          autoClose:3000,
       });
      }
             }else{
                console.log("undefined");
                window.location.reload();
             }

              })    
    }
  }
} catch (err) {
        console.log("1055",err.message);
        if (err.message == "Network Error")
        {
          toast.error("Error : Algorand Server Down", {
            position:'top-center',
            autoClose:3000,
            onClose: () => {window.location.reload()}
         });
        }
    }
    setTimeout(() => {
  }, 5000)

  };

  const fetchCbdcBalance = async (walletId) => {
    if (!walletId) return;
    setIsFetchingBalance(true);
    try {
      const resp = await fetch(
        config.API_ENDPOINT + `api/v1/cbdc/wallet/balance?walletId=${encodeURIComponent(walletId)}`,
        { headers: { "x-api-token": sessionStorage.getItem("traceChainAccessToken") } }
      );
      const data = await resp.json();
      if (data.success) {
        setCbdcBalance(data.data?.balance ?? null);
        setCbdcCurrency(data.data?.currency || "TRC-TOKEN");
      }
    } catch (err) {
      console.error("CBDC balance fetch failed:", err);
    } finally {
      setIsFetchingBalance(false);
    }
  };

  const fetchCbdcTxHistory = async () => {
    if (!cbdcWalletId) return;
    try {
      const resp = await fetch(
        config.API_ENDPOINT + `api/v1/cbdc/wallet/transactions?walletId=${encodeURIComponent(cbdcWalletId)}`,
        { headers: { "x-api-token": sessionStorage.getItem("traceChainAccessToken") } }
      );
      const data = await resp.json();
      if (data.success) setCbdcTxHistory(data.data?.transactions || []);
    } catch (err) {
      console.error("CBDC tx history fetch failed:", err);
    }
  };

  const topUpCbdcWallet = async () => {
    if (!cbdcWalletId) return;
    try {
      const resp = await fetch(config.API_ENDPOINT + "api/v1/cbdc/wallet/credit", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({ walletId: cbdcWalletId, amount: 50000, description: "Test top-up" })
      });
      const data = await resp.json();
      if (data.success) {
        toast.success("₹50,000 TRC-TOKEN added to your test wallet!", { position: "top-center", autoClose: 3000 });
        await fetchCbdcBalance(cbdcWalletId);
      } else {
        toast.error(data.errors?.[0]?.msg || "Top-up failed.", { position: "top-center", autoClose: 3000 });
      }
    } catch (err) {
      toast.error("Network error during top-up.", { position: "top-center", autoClose: 3000 });
    }
  };

  const generateCbdcWalletId = async () => {
    const stored = localStorage.getItem("buyerCbdcWalletId");
    if (stored) {
      setCbdcWalletId(stored);
      await fetchCbdcBalance(stored);
      toast.info("Your saved CBDC Wallet has been loaded.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    setIsGeneratingCbdc(true);
    try {
      const resp = await fetch(config.API_ENDPOINT + "api/v1/cbdc/test/create-wallet", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({ seedBalance: 100000, currency: "TRC-TOKEN" }),
      });
      const data = await resp.json();
      if (data.success && data.data?.walletId) {
        const { walletId, sessionToken, balance, currency } = data.data;
        setCbdcWalletId(walletId);
        setCbdcBalance(balance ?? 100000);
        setCbdcCurrency(currency || "TRC-TOKEN");
        localStorage.setItem("buyerCbdcWalletId", walletId);
        if (sessionToken) localStorage.setItem("cbdcSessionToken", sessionToken);
        toast.success(`Test wallet created! Balance: ₹${(balance ?? 100000).toLocaleString()} ${currency || "TRC-TOKEN"}`, { position: 'top-center', autoClose: 4000 });
      } else {
        toast.error(data.errors?.[0]?.msg || "Failed to create test CBDC wallet.", { position: 'top-center', autoClose: 4000 });
      }
    } catch (err) {
      console.error("CBDC wallet creation error:", err);
      toast.error("Failed to create CBDC wallet. Please try again.", { position: 'top-center', autoClose: 4000 });
    } finally {
      setIsGeneratingCbdc(false);
    }
  };

  const disconnectCbdcWallet = () => {
    localStorage.removeItem("buyerCbdcWalletId");
    localStorage.removeItem("cbdcSessionToken");
    setCbdcWalletId("");
    setCbdcBalance(null);
    setCbdcTxHistory([]);
    setShowCbdcTxPanel(false);
    toast.info("CBDC Wallet disconnected.", { position: 'top-center', autoClose: 2500 });
  };

  const isFabricNetwork = () => {
    if (props.nfts?.network_type === "hyperledger") return true;
    const ownerAddr = (selectedOwner || ownerofnft || props.nfts?.nft_sale?.[0]?.owner || "").toLowerCase();
    return /^trc-cbdc-/i.test(ownerAddr) || /^trc-test-/i.test(ownerAddr);
  };

  // Load balance on mount if wallet already stored
  useEffect(() => {
    const stored = localStorage.getItem("buyerCbdcWalletId");
    if (stored) fetchCbdcBalance(stored);
  }, []);

  const handleConfirmPurchaseFabric = async () => {
    const buyerWallet = cbdcWalletId.trim();
    if (!buyerWallet) {
      toast.error("Please enter your CBDC Wallet ID to proceed.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    const qty = parseFloat(numNfts);
    if (!qty || isNaN(qty) || qty <= 0) {
      toast.error("Please enter a valid quantity greater than 0.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    const sellerWallet = (selectedOwner || ownerofnft || props.nfts?.nft_sale?.[0]?.owner || "").toLowerCase();
    if (buyerWallet.toLowerCase() === sellerWallet) {
      toast.error("Buyer and seller cannot have the same CBDC Wallet ID.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    try {
      document.getElementById("confirmspin").style.display = "block";
      const authResp = await fetch(config.API_ENDPOINT + 'api/v1/cbdc/authenticate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({ cbdcWalletId: buyerWallet })
      });
      const authData = await authResp.json();
      if (!authData.success) {
        const msg = authData.data?.message || authData.errors?.[0]?.msg || "CBDC authentication failed. Check your Wallet ID.";
        toast.error(msg, { position: 'top-center', autoClose: 4000 });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }
      const cbdcSessionToken = authData.data?.sessionToken;
      const transferResp = await fetch(config.API_ENDPOINT + 'api/v1/fabric/nft/transfer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({ cbdcSessionToken, tokenId: props.nfts.tokenId, assetId: props.nfts.assetId, amount: qty })
      });
      const transferData = await transferResp.json();
      if (!transferData.success) {
        const msg = transferData.errors?.[0]?.msg || "Fabric transfer failed.";
        toast.error(msg, { position: 'top-center', autoClose: 4000 });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }
      // Debit buyer and credit seller in CBDC wallets
      const totalCbdcAmount = qty * parseFloat(priceofnft || 0);
      console.log("[CBDC Transfer] buyer:", buyerWallet, "seller:", sellerWallet, "amount:", totalCbdcAmount, "priceofnft:", priceofnft, "qty:", qty);
      if (totalCbdcAmount > 0 && sellerWallet) {
        const cbdcTransferResp = await fetch(config.API_ENDPOINT + 'api/v1/cbdc/wallet/transfer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem("traceChainAccessToken") },
          body: JSON.stringify({
            fromWalletId: buyerWallet,
            toWalletId: sellerWallet,
            amount: totalCbdcAmount,
            sessionToken: cbdcSessionToken,
            description: `NFT purchase - Token #${props.nfts.tokenId}`
          })
        });
        const cbdcTransferData = await cbdcTransferResp.json();
        console.log("[CBDC Transfer] response:", cbdcTransferData);
        if (!cbdcTransferData.success) {
          toast.error("CBDC payment failed: " + (cbdcTransferData.errors?.[0]?.msg || "Transfer rejected by server."), { position: 'top-center', autoClose: 5000 });
          document.getElementById("confirmspin").style.display = "none";
          return;
        }
      } else {
        console.warn("[CBDC Transfer] Skipped — amount:", totalCbdcAmount, "sellerWallet:", sellerWallet);
      }
      const updateResp = await fetch(config.API_ENDPOINT + 'src/v1/nftdetails/update_nftdetails', {
        method: "put",
        headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({
          assetId: props.nfts.assetId,
          material_received: "true",
          transactionProcess: "manual",
          network_type: "hyperledger",
          nft_sale: [{ owner: buyerWallet, ownerName: getBuyerDisplayName(), ownedCopies: Number(qty), previous_owner: selectedOwner || ownerofnft || props.nfts?.nft_sale?.[0]?.owner }]
        })
      });
      const updateData = await updateResp.json().catch(() => ({}));
      console.log("[NFT update_nftdetails] response:", updateData);
      if (updateData.success === false) {
        toast.error("NFT ownership update failed: " + (updateData.errors?.[0]?.msg || "DB update rejected."), { position: 'top-center', autoClose: 5000 });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }
      toast.success("NFT transferred via CBDC & Hyperledger Fabric!", { position: 'top-center', autoClose: 3000 });
      await fetchCbdcBalance(buyerWallet);
      setTimeout(() => {
        window.location.href = config.Local_ENDPOINT + `asset/${props.nfts.tokenId}/${assetType}?assetType=${assetType}&TokenId=${TokenId}`;
      }, 2000);
    } catch (error) {
      console.error("Fabric purchase error:", error);
      document.getElementById("confirmspin").style.display = "none";
      toast.error("Error: " + (error.message || "Transaction failed"), { position: 'top-center', autoClose: 4000 });
    }
  };

  const handleConfirmPurchaseEPRFabric = async () => {
    const buyerWallet = cbdcWalletId.trim();
    if (!buyerWallet) {
      toast.error("Please enter your CBDC Wallet ID to proceed.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    const qty = parseFloat(numNfts);
    if (!qty || isNaN(qty) || qty <= 0) {
      toast.error("Please enter a valid quantity greater than 0.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    const sellerWallet = (selectedOwner || ownerofnft || props.nfts?.nft_sale?.[0]?.owner || "").toLowerCase();
    if (buyerWallet.toLowerCase() === sellerWallet) {
      toast.error("Buyer and seller cannot have the same CBDC Wallet ID.", { position: 'top-center', autoClose: 3000 });
      return;
    }
    try {
      document.getElementById("confirmspin").style.display = "block";
      const authResp = await fetch(config.API_ENDPOINT + 'api/v1/cbdc/authenticate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({ cbdcWalletId: buyerWallet })
      });
      const authData = await authResp.json();
      if (!authData.success) {
        const msg = authData.data?.message || authData.errors?.[0]?.msg || "CBDC authentication failed. Check your Wallet ID.";
        toast.error(msg, { position: 'top-center', autoClose: 4000 });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }
      const cbdcSessionToken = authData.data?.sessionToken;
      const transferResp = await fetch(config.API_ENDPOINT + 'api/v1/fabric/nft/transferEPR', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({ cbdcSessionToken, tokenId: props.nfts.tokenId, assetId: props.nfts.assetId, certNumber: props.nfts.certNumber, amount: qty })
      });
      const transferData = await transferResp.json();
      if (!transferData.success) {
        const msg = transferData.errors?.[0]?.msg || "Fabric EPR transfer failed.";
        toast.error(msg, { position: 'top-center', autoClose: 4000 });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }
      // Debit buyer and credit seller in CBDC wallets
      const totalCbdcAmount = qty * parseFloat(priceofnft || 0);
      console.log("[CBDC EPR Transfer] buyer:", buyerWallet, "seller:", sellerWallet, "amount:", totalCbdcAmount, "priceofnft:", priceofnft, "qty:", qty);
      if (totalCbdcAmount > 0 && sellerWallet) {
        const cbdcTransferResp = await fetch(config.API_ENDPOINT + 'api/v1/cbdc/wallet/transfer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem("traceChainAccessToken") },
          body: JSON.stringify({
            fromWalletId: buyerWallet,
            toWalletId: sellerWallet,
            amount: totalCbdcAmount,
            sessionToken: cbdcSessionToken,
            description: `EPR NFT purchase - Token #${props.nfts.tokenId}`
          })
        });
        const cbdcTransferData = await cbdcTransferResp.json();
        console.log("[CBDC EPR Transfer] response:", cbdcTransferData);
        if (!cbdcTransferData.success) {
          toast.error("CBDC payment failed: " + (cbdcTransferData.errors?.[0]?.msg || "Transfer rejected by server."), { position: 'top-center', autoClose: 5000 });
          document.getElementById("confirmspin").style.display = "none";
          return;
        }
      } else {
        console.warn("[CBDC EPR Transfer] Skipped — amount:", totalCbdcAmount, "sellerWallet:", sellerWallet);
      }
      const updateResp = await fetch(config.API_ENDPOINT + 'src/v1/eprnftdetails/update_nftdetails', {
        method: "put",
        headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
        body: JSON.stringify({
          assetId: props.nfts.assetId,
          material_received: "true",
          transactionProcess: "manual",
          network_type: "hyperledger",
          nft_sale: [{ owner: buyerWallet, ownerName: getBuyerDisplayName(), ownedCopies: Number(qty), previous_owner: selectedOwner || ownerofnft }]
        })
      });
      const updateData = await updateResp.json().catch(() => ({}));
      console.log("[EPR update_nftdetails] response:", updateData);
      if (updateData.success === false) {
        toast.error("NFT ownership update failed: " + (updateData.errors?.[0]?.msg || "DB update rejected."), { position: 'top-center', autoClose: 5000 });
        document.getElementById("confirmspin").style.display = "none";
        return;
      }
      toast.success("EPR NFT transferred via CBDC & Hyperledger Fabric!", { position: 'top-center', autoClose: 3000 });
      await fetchCbdcBalance(buyerWallet);
      setTimeout(() => {
        window.location.href = config.Local_ENDPOINT + `asset/${TokenId}/${assetType}?assetType=${assetType}&TokenId=${TokenId}`;
      }, 2000);
    } catch (error) {
      console.error("Fabric EPR purchase error:", error);
      document.getElementById("confirmspin").style.display = "none";
      toast.error("Error: " + (error.message || "Transaction failed"), { position: 'top-center', autoClose: 4000 });
    }
  };

  const handleConfirmPurchaseUnified = () => {
    if (isFabricNetwork()) {
      if (assetType === "EPRAsset") {
        handleConfirmPurchaseEPRFabric();
      } else {
        handleConfirmPurchaseFabric();
      }
    } else if (props.nfts?.network_type === "algorand") {
      buyWithAlgos();
    } else {
      if (assetType === "EPRAsset") {
        handleConfirmPurchaseClickEPR();
      } else {
        handleConfirmPurchaseClick();
      }
    }
  };


// useEffect(()=>{
  const history = () => {
  console.log("history", showHistory);
  setShowHistory(true); 
  var tokenId = props.nfts.tokenId
  console.log("tokenId",tokenId);
  const viewnft = async () => await fetch(config.API_ENDPOINT+'src/v1/asset/nft/viewNFT?token_id='+tokenId,{
    method:"get",
    headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
          
  }
  ).then((response) => response.json())
  .then((result) => {
    const viewnftres = result.data.result;
    console.log("viewnftres",viewnftres)
    setviewNfts(viewnftres);
    console.log("v",viewnfts);
  });
  viewnft();
  console.log("v1",viewnfts);
 
  }

  const historyEPR = () => {
    console.log("history", showHistory);
    setShowHistory(true); 
    var tokenId = props.nfts.tokenId
    console.log("tokenId",tokenId);
    const viewnft = async () => await fetch(config.API_ENDPOINT+'src/v1/eprAsset/eprnft/vieweprnft?token_id='+tokenId,{
      method:"get",
      headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
            
    }
    ).then((response) => response.json())
    .then((result) => {
      const viewnftres = result.data.result;
      console.log("viewnftres",viewnftres)
      setviewNfts(viewnftres);
      console.log("v",viewnfts);
    });
    viewnft();
    console.log("v1",viewnfts);
   
    }

    const calculateFileHash = (fileData) => {
      const wordArray = CryptoJS.lib.WordArray.create(fileData);
      const hash = CryptoJS.MD5(wordArray).toString(CryptoJS.enc.Hex);
      return hash;
    };


 const getFileOnS3 = async (bucketName, keyName) => {

  const awsDetails = {
    "accessKeyId": "AKIA2JDSZ5DE2NYBCANH",
    "secretAccessKey": "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",
    "region": "ap-south-1",
    "bucket": "tracechain-2026",
    "signatureVersion": "v4",
    "url": "https://tracechain-2026.s3.ap-south-1.amazonaws.com",
    "emailregion": "eu-west-1",
  }
  AWS.config.update({
    accessKeyId: awsDetails.accessKeyId,
    secretAccessKey: awsDetails.secretAccessKey,
    region: awsDetails.region,
    signatureVersion: awsDetails.signatureVersion
  });
  var s3 = new AWS.S3();
  const signedUrlExpireSeconds = 60 * 5
  var s3Client = new S3Client();

  var options = {
    Bucket: bucketName,
    Key: keyName,
  };

  return new Promise((resolve, reject) => {

    var file = s3.getObject(options, async function (err, data) {
      console.log("data",data);
      console.log("file",file);
      console.log("err",err);
      console.log("data",data);
      if (err) {
        reject(err)
        return
      } else {
        resolve(data)
      }
    })


  });
}



 const verify = () => {
  const toastId = toast.loading("Verifying product on Blockchain...", {
    position: 'top-center',
    closeButton: true,
  });

  if(assetType == "NonEprAsset"){
  console.log(props?.nfts, "Assetdetails");
  const path1 = "https://tracechain-2026.s3.ap-south-1.amazonaws.com/provenance/"+props?.nfts?.provenanceTemplatePath+"/"+props?.nfts?.transactionid+".html";
  const contentType = "text/html";
  const bucketName = "tracechain-2026";

  const keyName = "provenance/"+props?.nfts?.provenanceTemplatePath+"/"+props?.nfts?.transactionid+".html";
  console.log(path1);

  getFileOnS3(bucketName, keyName).then(data => {
    console.log("In S3 Function",data.Body)
    const s3FileHash = calculateFileHash(data.Body);
    console.log("s3Hash", s3FileHash);
    const provHash = props?.nfts?.provenanceHash;
    console.log("Hash From NFT", provHash);

    if (provHash == s3FileHash) {
      console.log("Product is Verified from BlockChain Platform!");
      toast.update(toastId, {
        render: "Product is Verified from BlockChain Platform!",
        type: "success",
        isLoading: false,
        position: 'top-center',
        autoClose: 5000,
        closeButton: true,
        closeOnClick: true,
      });
    }
    else {
      console.log("Product is not Verified from BlockChain Platform!");
      toast.update(toastId, {
        render: "Product is not Verified from BlockChain Platform!",
        type: "error",
        isLoading: false,
        position: 'top-center',
        autoClose: 5000,
        closeButton: true,
        closeOnClick: true,
      });
    }
    return data;

  }).catch(() => {
    toast.update(toastId, {
      render: "Verification failed. Please try again.",
      type: "error",
      isLoading: false,
      position: 'top-center',
      autoClose: 5000,
      closeButton: true,
      closeOnClick: true,
    });
  });
  }else{

    const EPRCertHash = props?.nfts?.eprcertHash;
    console.log("EPRcertHash",EPRCertHash);

    const EPRCertName = props?.nfts?.certNumber;
    console.log("EPRcert",EPRCertName);
    const EPRnum = props?.nfts?.certNumber.split("/");
    console.log("NUM:",EPRnum);
    const EPRCert = EPRnum[4];
    console.log("name",EPRCert);
      const path1 =  "https://eprcertificate-2026.s3.ap-south-1.amazonaws.com/"+EPRCert+".pdf"
      const contentType = "text/pdf";
      const bucketName = "eprcertificate-2026";

      const keyName = EPRCert+".pdf";
      console.log(path1);

      getFileOnS3(bucketName, keyName).then(data => {
        console.log("In S3 Function",data.Body)
        const s3FileHash = calculateFileHash(data.Body);
        console.log("s3Hash", s3FileHash);
        const stringWithQuotes = s3FileHash;
        const stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');
        console.log("stringWithoutQuotes",stringWithoutQuotes);
        const finals3Hash = stringWithoutQuotes;
        console.log("Hash from AWS", finals3Hash);
        const certHash = EPRCertHash
        const stringWithQuotes1 = certHash;
        const stringWithoutQuotes1 = stringWithQuotes1.replace(/"/g, '');
        console.log("stringWithoutQuotes1",stringWithoutQuotes1);
        const finalNftHash = stringWithoutQuotes1;
        console.log("Hash From NFT", finalNftHash);

        if (finalNftHash == finals3Hash) {
          toast.update(toastId, {
            render: "Product is Verified from BlockChain Platform!",
            type: "success",
            isLoading: false,
            position: 'top-center',
            autoClose: 5000,
            closeButton: true,
            closeOnClick: true,
          });
        }
        else {
          toast.update(toastId, {
            render: "Product is not Verified from BlockChain Platform!",
            type: "error",
            isLoading: false,
            position: 'top-center',
            autoClose: 5000,
            closeButton: true,
            closeOnClick: true,
          });
        }
        return data;

      }).catch(() => {
        toast.update(toastId, {
          render: "Verification failed. Please try again.",
          type: "error",
          isLoading: false,
          position: 'top-center',
          autoClose: 5000,
          closeButton: true,
          closeOnClick: true,
        });
      });
      }

}
  
  

  if(props?.nfts?.nft_sale?.length > 0 ){
  let EprCertName ="";
  console.log("nfts",props?.nfts);
  if(props.nfts?.assetImg == null)
  {
      image_link = null
  }else{
      image_link = props.nfts?.assetImg
  }
  if(assetType == "EPRAsset"){
  
  const EPRCert = props?.nfts?.certNumber;
  console.log("EPRcert",EPRCert);
  const EPRnum = props?.nfts?.certNumber.split("/");
  console.log("NUM:",EPRnum);
  EprCertName = EPRnum[4];
  console.log("name",EprCertName);
  }
  
  console.log("nftsale",props?.nfts?.nft_sale);
  for (let i = 0; i <= props?.nfts?.nft_sale?.length; i++){
  
  
  return (
     <div>
      <ToastContainer closeButton={true} closeOnClick={true} />
      <div className="asset-page-row row">
        {/* <div className="col-5 "> */}
        <div className="col-md-5 asset-img-panel">
          <Link to={"/home"} className="asset-back-icon" title="Back to Marketplace">
            <i className="fa-solid fa-hand-point-left"></i>
          </Link>

          <div className="asset-img-wrapper">
            {assetType === "NonEprAsset" ? (
              props?.nfts?.assetImg && !props?.nfts?.assetImg.toLowerCase().endsWith('.pdf') ? (
                <img src={props?.nfts?.assetImg} className="img-fluid img-product asset-img" alt="nft" />
              ) : (
                <div className="noneprimagecard card-img-top img-card eprimgassetpage"></div>
              )
            ) : (
              <div className="eprimagecard card-img-top img-card eprimgassetpage">
                <div alt="nft" className="epr-asset-text">{"Plastic Credit"}</div>
                <div alt="nft" className="epr-asset-text">{props?.nfts?.no_of_copies} {props?.nfts?.eprAssetUom}</div>
              </div>
            )}
          </div>

          <div className="asset-img-actions">
            <Button className="buttonAsset asset-action-btn" onClick={verify}>Verify Product</Button>
            {(assetType == "EPRAsset" && EprCertName !== "") ? (
              <Button className="buttonAsset asset-action-btn"><Link to={"https://eprcertificate-2026.s3.ap-south-1.amazonaws.com/"+EprCertName+".pdf"} target={"_blank"} className="a1">View Product Details</Link></Button>
            ) : (
              <Button className="buttonAsset asset-action-btn"><Link to={"https://tracechain-2026.s3.ap-south-1.amazonaws.com/provenance/"+props?.nfts?.provenanceTemplatePath+"/"+props?.nfts?.transactionid+".html"} target={"_blank"} className="a1">View Product Details</Link></Button>
            )}
          </div>
        </div>
        

        <div className="col-md-7 asset-details-panel">
          <div className="">
            <h2 className="h2productcard asset-nft-title">
              {props.nfts !== undefined ? (
                <b>{props.nfts.assetName+" - "+props.nfts.assetId}</b>
              ) : (
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </h2>
          </div>
          

         
        {/* ── CBDC Wallet Panel (Fabric assets only) ── */}
        {isFabricNetwork() && (
          <div style={{
            margin: "0 0 10px 0",
            background: cbdcWalletId ? "#eff3ff" : "#fff8f0",
            border: `1px solid ${cbdcWalletId ? "#001F60" : "#f97316"}`,
            borderRadius: "8px",
            padding: "12px 14px",
          }}>
            {cbdcWalletId ? (
              /* ── Connected state ── */
              <div>
                {/* Row 1: icon + wallet ID + disconnect */}
                <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                  <AccountBalanceWalletIcon style={{ color: "#001F60", fontSize: "16px", flexShrink: 0 }} />
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#001F60", whiteSpace: "nowrap" }}>CBDC Wallet</span>
                  <span style={{ fontSize: "11px", fontFamily: "monospace", color: "#333", background: "rgba(0,31,96,0.07)", padding: "2px 6px", borderRadius: "4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, minWidth: 0 }} title={cbdcWalletId}>
                    {cbdcWalletId}
                  </span>
                  <Button onClick={disconnectCbdcWallet} style={{ fontSize: "10px", padding: "2px 8px", borderRadius: "4px", background: "#fff", color: "#c0392b", border: "1px solid #c0392b", textTransform: "none", fontWeight: "600", flexShrink: 0, minWidth: 0 }}>
                    Disconnect
                  </Button>
                </div>
                {/* Row 2: balance */}
                <div style={{ marginTop: "8px", display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                  <span style={{ fontSize: "12px", color: "#374151" }}>Balance:</span>
                  <span style={{ fontSize: "14px", fontWeight: "700", color: "#001F60" }}>
                    {isFetchingBalance ? "…" : cbdcBalance !== null ? `₹${Number(cbdcBalance).toLocaleString()} ${cbdcCurrency}` : "—"}
                  </span>
                  <Button onClick={() => fetchCbdcBalance(cbdcWalletId)} disabled={isFetchingBalance} style={{ fontSize: "10px", padding: "2px 8px", borderRadius: "4px", background: "#fff", color: "#001F60", border: "1px solid #001F60", textTransform: "none", fontWeight: "600", minWidth: 0 }}>
                    ↻ Refresh
                  </Button>
                  <Button onClick={topUpCbdcWallet} style={{ fontSize: "10px", padding: "2px 8px", borderRadius: "4px", background: "#001F60", color: "#fff", border: "none", textTransform: "none", fontWeight: "600", minWidth: 0 }}>
                    + Top Up ₹50k
                  </Button>
                  <Button onClick={async () => { setShowCbdcTxPanel(v => !v); if (!showCbdcTxPanel) await fetchCbdcTxHistory(); }} style={{ fontSize: "10px", padding: "2px 8px", borderRadius: "4px", background: "#f0f4ff", color: "#001F60", border: "1px solid #c7d6f8", textTransform: "none", fontWeight: "600", minWidth: 0 }}>
                    {showCbdcTxPanel ? "Hide Txns" : "View Txns"}
                  </Button>
                </div>
                {/* Row 3: transaction history panel */}
                {showCbdcTxPanel && (
                  <div style={{ marginTop: "10px", maxHeight: "160px", overflowY: "auto", borderRadius: "6px", border: "1px solid #dde5f8", background: "#fff" }}>
                    {cbdcTxHistory.length === 0 ? (
                      <div style={{ padding: "10px 12px", fontSize: "11px", color: "#888" }}>No transactions found.</div>
                    ) : (
                      <table style={{ width: "100%", fontSize: "11px", borderCollapse: "collapse" }}>
                        <thead>
                          <tr style={{ background: "#f0f4ff", position: "sticky", top: 0 }}>
                            <th style={{ padding: "5px 8px", textAlign: "left", color: "#001F60" }}>Type</th>
                            <th style={{ padding: "5px 8px", textAlign: "right", color: "#001F60" }}>Amount</th>
                            <th style={{ padding: "5px 8px", textAlign: "right", color: "#001F60" }}>Balance</th>
                            <th style={{ padding: "5px 8px", textAlign: "left", color: "#001F60" }}>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cbdcTxHistory.slice().reverse().map((tx, i) => (
                            <tr key={i} style={{ borderTop: "1px solid #eef2ff" }}>
                              <td style={{ padding: "4px 8px", color: tx.type === "credit" ? "#16a34a" : "#dc2626", fontWeight: "600", textTransform: "capitalize" }}>{tx.type}</td>
                              <td style={{ padding: "4px 8px", textAlign: "right", color: tx.type === "credit" ? "#16a34a" : "#dc2626" }}>{tx.type === "credit" ? "+" : "-"}₹{Number(tx.amount).toLocaleString()}</td>
                              <td style={{ padding: "4px 8px", textAlign: "right", color: "#374151" }}>₹{Number(tx.runningBalance ?? tx.balance).toLocaleString()}</td>
                              <td style={{ padding: "4px 8px", color: "#6b7280", maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={tx.description}>{tx.description || "—"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            ) : (
              /* ── Not connected state ── */
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                  <AccountBalanceWalletIcon style={{ color: "#f97316", fontSize: "20px" }} />
                  <span style={{ fontSize: "12px", fontWeight: "600", color: "#9a3412" }}>
                    Hyperledger Fabric asset — Connect your CBDC Wallet to purchase
                  </span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <input
                    type="text"
                    className="form-control"
                    style={{ flex: 1, fontSize: "12px", padding: "6px 10px" }}
                    value={cbdcWalletId}
                    onChange={(e) => { setCbdcWalletId(e.target.value); localStorage.setItem("buyerCbdcWalletId", e.target.value); }}
                    placeholder="Enter or generate your CBDC Wallet ID..."
                    autoComplete="off"
                  />
                  <Button
                    onClick={generateCbdcWalletId}
                    disabled={isGeneratingCbdc}
                    style={{ whiteSpace: "nowrap", fontSize: "11px", padding: "6px 14px", backgroundColor: isGeneratingCbdc ? "#929090" : "#001F60", color: "#fff", borderRadius: "6px", textTransform: "none", fontWeight: "600", flexShrink: 0 }}
                  >
                    <AccountBalanceWalletIcon style={{ fontSize: "14px", marginRight: "5px", verticalAlign: "middle" }} />
                    {isGeneratingCbdc ? "Generating..." : "Create Test Wallet"}
                  </Button>
                </div>
                <div style={{ fontSize: "11px", color: "#888", marginTop: "6px" }}>
                  Click "Create Test Wallet" to get a new wallet with ₹1,00,000 TRC-TOKEN seeded balance, or paste an existing Wallet ID above.
                </div>
              </div>
            )}
          </div>
        )}

        <div>
        <div
          className="asset-section-label"
          onClick={() => setOwnerTableOpen(o => !o)}
          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", userSelect: "none" }}
        >
          <span>Owner &amp; Sale Details</span>
          <span style={{ fontSize: "13px", color: "#001F60", transition: "transform 0.2s", display: "inline-block", transform: ownerTableOpen ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
        </div>
        {ownerTableOpen && (
        <TableContainer component={Paper} className="asset-table-container">
              <Table className="tblOwnerDetails owner-sale-table" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className="owner-th">Owner Name</TableCell>
                    <TableCell className="owner-th owner-addr-col">Owner Address</TableCell>
                    <TableCell className="owner-th">Available Quantity</TableCell>
                    <TableCell className="owner-th">OnSale</TableCell>
                    <TableCell className="owner-th">Price(USD)</TableCell>
                    <TableCell className="owner-th">Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(props?.nfts?.nft_sale || []).map((saleEntry, idx) => {
                    const techNames = props.nfts.certNumber ? props.nfts.certNumber.split("/")[1] : "";
                    const rowOwnerName = saleEntry.ownerName || techNames;
                    const rowQty = saleEntry.ownedCopies;
                    const rowSaleCopies = saleEntry.sale_copies;
                    const rowPrice = saleEntry.fixedPrice;
                    const rowOwner = saleEntry.owner;
                    const rowUom = assetType === "EPRAsset"
                      ? (props.nfts.eprAssetUom || "")
                      : (props.nfts.AssetUom || props.nfts.assetUom || "");
                    const shortAddr = rowOwner ? rowOwner.slice(0, 8) + "..." + rowOwner.slice(-6) : "";
                    return (
                      <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell className="owner-td"><b>{rowOwnerName}</b></TableCell>
                        <TableCell className="owner-td owner-addr-col">
                          {props?.nfts?.network_type === "algorand" ? (
                            <Link to={"https://testnet.algoexplorer.io/address/" + rowOwner} target={"_blank"} title={rowOwner}><b>{shortAddr}</b></Link>
                          ) : (
                            <Link to={"https://www.oklink.com/amoy/address/" + rowOwner} target={"_blank"} title={rowOwner}><b>{shortAddr}</b></Link>
                          )}
                        </TableCell>
                        <TableCell className="owner-td"><b>{rowQty} {rowUom}</b></TableCell>
                        <TableCell className="owner-td"><b>{rowSaleCopies} {rowUom}</b></TableCell>
                        <TableCell className="owner-td"><b>{rowPrice}</b></TableCell>
                        <TableCell align="left">
                          <Button
                            variant="contained"
                            sx={{"&.Mui-disabled": {backgroundColor: "#eaeaea", color: "#c0c0c0"}}}
                            disabled={props.isValid === false || Number(rowSaleCopies) === 0 || rowPrice === "null" || !rowPrice}
                            className="buttonbuynft button-font"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() => {
                              const ppu = parseFloat(rowPrice) || 0;
                              const qtySale = parseFloat(rowSaleCopies) || 0;
                              const totalMatic = qtySale * ppu;
                              const rate = parseFloat(price);
                              setSelectedOwner(rowOwner);
                              setpriceofnft(rowPrice);
                              setsale_copies_of_nft(rowSaleCopies);
                              setNumNfts(rowSaleCopies);
                              setownerNameofnft(rowOwnerName);
                              setquantityofnft(rowQty);
                              setvalueString(rowSaleCopies);
                              // 6 decimal places — toFixed(2) rounds 0.004 → "0.00"
                              setMaticPrice(totalMatic.toFixed(6));
                              // price = USD per 1 MATIC (CoinGecko), totalUSD = totalMatic × price
                              setTotalPrice(!isNaN(rate) && rate > 0 ? (totalMatic * rate).toFixed(4) : "N/A");
                            }}
                          >
                            <b>Buy</b>
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

              </Table>
            </TableContainer>
        )}

        </div>

  <div className="asset-accordion-wrapper">
  <div className="accordion asset-accordion" id="accordionExample">

    <div className="accordion-item">
      <h2 className="accordion-header" id="headingOne">

      <button
        hidden={assetType ==="NonEprAsset"}
        className="accordion-button asset-accordion-btn acc-history"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
        aria-expanded="false"
        aria-controls="collapseOne"
        onClick={historyEPR}
        >
        <i className="fa-solid fa-clock-rotate-left asset-acc-icon"></i>
        &nbsp;&nbsp;<b>View History</b>
        </button>

        <button
        hidden={assetType ==="EPRAsset"}
        className="accordion-button asset-accordion-btn acc-history"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
        aria-expanded="false"
        aria-controls="collapseOne"
        onClick={history}
        >
        <i className="fa-solid fa-clock-rotate-left asset-acc-icon"></i>
        &nbsp;&nbsp;<b>View History</b>
        </button>
        
      </h2>
      
      <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
        <div className="accordion-body">
        {props.nfts.network_type == "polygon" ? (
        <TableContainer component={Paper} hidden = {(showHistory == false)}>
        
        <Table sx={{ minWidth: 750 }} style={{ border: "0px !important" }} aria-label="simple table" >
          
            <TableHead>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="left" style={{ width: 200, fontSize : "17px !important" }} className="historycolumns"> <b>Txn Hash</b> </TableCell>
                <TableCell align="left" style={{ width: 200, fontSize : "17px !important" }} > <b>From</b> </TableCell>
                <TableCell align="left" style={{ width: 200, fontSize : "17px !important" }} > <b>To</b>  </TableCell>
                <TableCell align="left" style={{ width: 200, fontSize : "17px !important" }}> <b>Quantity</b> </TableCell>
                <TableCell align="left" style={{ width: 200, fontSize : "17px !important" }} > <b>Date and Time</b> </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            {viewnfts.map((nft) => (
                  // Convert ytc block_timestamp to local time
                utcTimestamp = new Date(nft.block_timestamp),
                localDate = utcTimestamp.toLocaleDateString(),
                localTime = utcTimestamp.toLocaleTimeString(),
                console.log("localTimestamp",localDate , localTime),
                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  
                  <TableCell align="left"><div className="historycolumns"><b>{nft.transaction_hash}</b></div></TableCell>
                  <TableCell align="left"><div className="historycolumns"><b>{nft.from_address}</b></div></TableCell>
                  <TableCell align="left"><div className="historycolumns"><b>{nft.to_address}</b></div></TableCell>
                  <TableCell align="left"><div className="historycolumns" style={{width : "100px !important"}}><b>{nft.amount}</b></div></TableCell>
                  <TableCell align="left"><div className="historycolumns"><b>{localDate}  {localTime}</b></div></TableCell>
                
                </TableRow>
                

              ))} 

              
              
              
            </TableBody>
            
          </Table>
        </TableContainer>
      ) : isFabricNetwork() ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="fabric-history-table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: "12px" }}><b>From</b></TableCell>
                <TableCell style={{ fontSize: "12px" }}><b>To (Current Owner)</b></TableCell>
                <TableCell style={{ fontSize: "12px" }}><b>Owner Name</b></TableCell>
                <TableCell style={{ fontSize: "12px" }}><b>Quantity</b></TableCell>
                <TableCell style={{ fontSize: "12px" }}><b>Network</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(props.nfts.nft_sale || []).map((entry, idx) => {
                const shortFrom = entry.previous_owner
                  ? entry.previous_owner.slice(0, 8) + "..." + entry.previous_owner.slice(-6)
                  : "—";
                const shortTo = entry.owner
                  ? entry.owner.slice(0, 8) + "..." + entry.owner.slice(-6)
                  : "—";
                const uom = assetType === "EPRAsset"
                  ? (props.nfts.eprAssetUom || "")
                  : (props.nfts.assetUom || "");
                return (
                  <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell style={{ fontSize: "12px" }} title={entry.previous_owner || ""}>{shortFrom}</TableCell>
                    <TableCell style={{ fontSize: "12px" }} title={entry.owner || ""}>{shortTo}</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>{entry.ownerName || "—"}</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>{entry.ownedCopies} {uom}</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>Hyperledger Fabric</TableCell>
                  </TableRow>
                );
              })}
              {(!props.nfts.nft_sale || props.nfts.nft_sale.length === 0) && (
                <TableRow>
                  <TableCell colSpan={5} align="center" style={{ fontSize: "12px", color: "#888" }}>No transfer history found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableContainer component={Paper} hidden={(showHistory == false)}>
          <Table sx={{ minWidth: 750 }} style={{ border: 1 }} aria-label="simple table">
            <TableHead>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <p style={{ textAlign: "center", backgroundColor: "#e9ecef !important" }}>History Coming Soon!!</p>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
      

         
        </div>
      </div>
    </div>

    <div className="accordion-item">
      <h2 className="accordion-header" id="headingTwo">
        <button
        className="accordion-button collapsed asset-accordion-btn acc-details"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
        aria-expanded="false"
        aria-controls="collapseTwo">
        <i className="fa-solid fa-list-ul asset-acc-icon"></i>
        &nbsp;&nbsp;<b>View Details</b>
        </button>
      </h2>
      <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
        <div className="accordion-body">
        <div className="table-responsive">

           {props.nfts.network_type === "polygon" ? (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} style={{ border: "0px !important" }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell align="left" style={{ width: 200, fontSize: "12px" }} className="detailscolumns"> <b>Asset ID</b> </TableCell>
              <TableCell align="left" style={{ width: 200, fontSize: "12px" }}> <b>Asset Name</b> </TableCell>
              <TableCell align="left" style={{ width: 200, fontSize: "12px" }}> <b>Platform</b> </TableCell>
              <TableCell align="left" style={{ width: 200, fontSize: "12px" }}> <b>Created Date</b> </TableCell>
              <TableCell align="left" style={{ width: 200, fontSize: "12px" }}> <b>Contract Address</b> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell align="left" style={{ fontSize: "12px" }}>{props.nfts.assetId}</TableCell>
              <TableCell align="left" style={{ fontSize: "12px" }}>{props.nfts.assetName}</TableCell>
              <TableCell align="left" style={{ fontSize: "12px" }}>{isFabricNetwork() ? "Hyperledger Fabric" : props.nfts.network_type}</TableCell>
              <TableCell align="left" style={{ fontSize: "12px" }}>{localDate1} {localTime1}</TableCell>
               {assetType == "EPRAsset" ? (
               <TableCell align="left" style={{ fontSize: "12px" }}><a href="https://www.oklink.com/amoy/address/0x1c36a5B65a44744f0F536b922edd07669aF8565e" target="_blank">0x1c36...8565e</a></TableCell>
               ) :(
                <TableCell align="left" style={{ fontSize: "12px" }}><a href="https://www.oklink.com/amoy/address/0x7B08e049ebae3eCED91a234223D23E97e4B7770e" target="_blank">0x7B08...770e</a></TableCell>
               )}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    ) : (
      <div style={{ width: "100%", fontSize: "12px" }}>
        <div style={{ paddingTop: "10px", paddingLeft: "34px", paddingRight: "34px", justifyContent: "space-between", display: "flex" }}>Asset ID <span style={{ justifyContent: "space-between" }}>{props.nfts.assetId}</span></div><br></br>
        <div style={{ paddingLeft: "34px", paddingRight: "34px", justifyContent: "space-between", display: "flex" }}>Asset Name <span style={{ paddingLeft: "300px" }}>{props.nfts.assetName}</span></div><br></br>
        <div style={{ paddingLeft: "34px", paddingRight: "34px", justifyContent: "space-between", display: "flex" }}>Platform <span style={{ paddingLeft: "300px" }}>{isFabricNetwork() ? "Hyperledger Fabric" : props.nfts.network_type}</span></div><br></br>
        <div style={{ paddingLeft: "34px", paddingRight: "34px", justifyContent: "space-between", display: "flex" }}>Created Date <span style={{ paddingLeft: "300px" }}>{localDate1} {localTime1}</span></div><br></br>
      </div>
    )}
     
        


        </div>
        </div>
      </div>
    </div>

   
  </div>

  </div>

  {/* ── Blockchain Badge Strip ── */}
  <div className="bc-badge-strip">
    <div className="bc-badge">
      <span className="bc-badge-label">Network</span>
      <span className="bc-badge-value">
        <i className={`fa-solid ${props.nfts.network_type === "polygon" ? "fa-circle-nodes" : "fa-link"} bc-badge-icon`}></i>
        {props.nfts.network_type ? props.nfts.network_type.charAt(0).toUpperCase() + props.nfts.network_type.slice(1) : "—"}
      </span>
    </div>
    <div className="bc-badge">
      <span className="bc-badge-label">Token ID</span>
      <span className="bc-badge-value">#{props.nfts.tokenId || "—"}</span>
    </div>
    {!isFabricNetwork() && (
      <div className="bc-badge">
        <span className="bc-badge-label">Contract</span>
        <span className="bc-badge-value">
          {assetType === "EPRAsset" ? (
            <a href="https://www.oklink.com/amoy/address/0x1c36a5B65a44744f0F536b922edd07669aF8565e" target="_blank" rel="noreferrer" className="bc-badge-link">
              0x1c36...8565e
            </a>
          ) : (
            <a href="https://www.oklink.com/amoy/address/0x7B08e049ebae3eCED91a234223D23E97e4B7770e" target="_blank" rel="noreferrer" className="bc-badge-link">
              0x7B08...770e
            </a>
          )}
        </span>
      </div>
    )}
  </div>


        </div>
      </div>



      <div
        className="modal"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        role="dialog"
        style={{ maxWidth: '100%', margin: 'auto' }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop : "100px"}}>
            <div className="modal-header" style={{paddingTop:"1px", paddingBottom:"1px", paddingLeft:"3px",paddingRight:"3px"}}>
              <h6 className="modal-title" id="exampleModalLabel" style={{marginTop: "5px"}}>
                Buy Asset
              </h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
            {assetType == "EPRAsset" ?
            (
              <div className="form-group">
              <label htmlFor="numNftsInput" style={{paddingTop:"2px"}}>Quantity</label>
              <input
              style ={{marginTop:"5px"}}
                required
                type="number"
                className="form-control"
                id="numNftsInput"
                value={numNfts}
                onChange={handleNumNftsInputEPR}
                min="1"
                max={sale_copies_of_nft}
              />
              {(!numNfts || numNfts == 0) && <div className="error-message" style={{marginBottom:"2px"}}>Please provide Quantity greater than 0</div>}
              {numNfts > sale_copies_of_nft && <div className="error-message" style={{marginBottom:"2px"}}>Please enter quantity less than or equal to available sale quantity!</div>}
            </div>
            ):(
              <div className="form-group">
                <label htmlFor="numNftsInput" style={{paddingTop:"2px"}}>Quantity</label>
                <input
                style ={{marginTop:"5px"}}
                  required
                  type="number"
                  className="form-control"
                  id="numNftsInput"
                  value={numNfts}
                  onChange={handleNumNftsInput}
                  min="1"
                  max= {sale_copies_of_nft}
                />
                {!numNfts && numNfts==0 && <div className="error-message" style={{marginBottom:"2px"}}>Please provide Quantity greater than 0</div>}
                {numNfts > sale_copies_of_nft && <div className="error-message" style={{marginBottom:"2px"}}>Please enter quantity lesser than onSale quantity!</div>}
              </div>
            )}
              {props.nfts.network_type === "algorand" ? (
                <p style={{fontSize:"13px", marginTop:"20px"}}>Total ALGO : <b>{maticPrice}</b> ALGO</p>
              ) : isFabricNetwork() ? (
                <>
                  <p style={{fontSize:"13px", marginTop:"20px"}}>
                    Total (INR Digital Currency) : <b>{maticPrice || "—"}</b> INR
                    &nbsp;<small style={{color:"#888"}}>({parseFloat(priceofnft)} INR per unit)</small>
                  </p>
                  <p style={{fontSize:"13px", marginBottom:"2px"}}>
                    Total Price in USD : <b>{totalPrice && totalPrice !== "N/A" ? totalPrice : "—"}</b>
                    {totalPrice && totalPrice !== "N/A" ? " USD" : " (rate unavailable)"}
                  </p>
                </>
              ) : (
                <>
                  <p style={{fontSize:"13px", marginTop:"20px"}}>Total MATIC : <b>{maticPrice}</b> MATIC &nbsp;<small style={{color:"#888"}}>({parseFloat(priceofnft)} MATIC per unit)</small></p>
                  <p style={{fontSize:"13px", marginBottom:"2px"}}>Total Price in USD : <b>{totalPrice !== "N/A" ? totalPrice : "—"}</b> {totalPrice !== "N/A" ? "USD" : "(price data unavailable)"}</p>
                </>
              )}
              {isFabricNetwork() && (
                <div style={{marginTop:"12px", padding:"10px 12px", background: cbdcWalletId ? "#eff3ff" : "#fff3f3", borderRadius:"8px", border: `1px solid ${cbdcWalletId ? "#001F60" : "#f87171"}`}}>
                  <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                    <AccountBalanceWalletIcon style={{fontSize:"16px", color: cbdcWalletId ? "#001F60" : "#ef4444"}} />
                    <span style={{fontSize:"12px", fontWeight:"600", color: cbdcWalletId ? "#001F60" : "#b91c1c"}}>
                      {cbdcWalletId ? "CBDC Wallet" : "No CBDC Wallet Connected"}
                    </span>
                    {cbdcWalletId && cbdcBalance !== null && (
                      <span style={{marginLeft:"auto", fontSize:"12px", fontWeight:"700", color:"#001F60"}}>
                        Balance: ₹{Number(cbdcBalance).toLocaleString()} {cbdcCurrency}
                      </span>
                    )}
                  </div>
                  {cbdcWalletId
                    ? <div style={{fontFamily:"monospace", fontSize:"11px", color:"#333", marginTop:"6px", wordBreak:"break-all", background:"rgba(0,31,96,0.07)", padding:"4px 8px", borderRadius:"4px"}}>{cbdcWalletId}</div>
                    : <div style={{fontSize:"11px", color:"#888", marginTop:"6px"}}>Go back and connect your CBDC Wallet on the asset page to proceed.</div>
                  }
                </div>
              )}
            </div>
            <div className="modal-footer button-section" style={{marginTop:"2px"}}>
              <Button
                type="button"
                className="buttonclosemodal close-button"
                data-bs-dismiss="modal"
                onClick={handleCloseModal}
                >
                Cancel
              </Button>
              <Button
                type="button"
                className="buttonconfirmprod size-change"
                onClick={handleConfirmPurchaseUnified}
                disabled={!numNfts || numNfts == 0 || numNfts > sale_copies_of_nft || (isFabricNetwork() && !cbdcWalletId.trim())}
              >
                Confirm Purchase
              </Button>
             <div id="confirmspin" className="loader" style={{ display: "none" }}>Loading...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
 }


}
}

export default Asset;

